const PBP_ENROLL_PAGES = {
    FIND_PLAN: 1,
    SELECT_PLAN: 2,
    SOA_CONFIRM: 3,
    ENROLLMENT: 4,
    REVIEW: 5,
    CONFIRMATION: 6,
    OPTIONAL_BENEFITS_PLAN: 7,
};
const PBP_ENROLL_SUBPAGES = {
    // ENROLLMENT PAGE
    ELIGIBILITY: 1,
    CLIENT_INFO: 2,
    ADDITIONAL_INFO: 3,
    SNP_PREQUALIFICATION: 4,

    // SELECT PLANS PAGE
    SELECT_PLAN: 1,
    COMPARE_PLAN: 2,

    // SOA CONFIRMATION
    TELESALES_AGENT: 1,
    FIELD_AGENT: 2,
};
export { PBP_ENROLL_PAGES, PBP_ENROLL_SUBPAGES };
